
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.805","height":"13.973"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_30611","data-name":"Path 30611","d":"M17.205 2.516v8.941a1.916 1.916 0 01-1.916 1.916H2.516A1.916 1.916 0 01.6 11.457V2.516m16.6 0A1.916 1.916 0 0015.289.6H2.516A1.916 1.916 0 00.6 2.516m16.6 0v.207a1.916 1.916 0 01-.911 1.632l-6.386 3.93a1.916 1.916 0 01-2.01 0l-6.382-3.93A1.916 1.916 0 01.6 2.724v-.208","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}})])
          )
        }
      }
    